<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'ContactUs',

    metaInfo: { title: 'Contact' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'contact-us',
        'keep-in-touch',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'contact',
      },
    },
  }
</script>
